module.exports = __webpack_public_path__ + "static/img/prezzta3.8741630e.svg";